/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Nobody_Joined_TitleInputs */



/**
* | output |
* | --- |
* | "Nobody showed up" |
*
* @param {Meeting_Notetaker_Issue_Nobody_Joined_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_nobody_joined_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Nobody_Joined_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Nobody_Joined_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niemand kwam opdagen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personne n'est venu")
	return /** @type {LocalizedString} */ ("Nobody showed up")
});